import { Box } from '@chakra-ui/react';
import { Text } from 'components/ui';
import { UserEligibility } from '../../api/user/useUserEligibility';

const RELATIONSHIP_LABELS: Record<string, string> = {
  self: 'Self',
  spouse: 'Spouse',
  child: 'Child',
  other: 'Other',
};

type Row = {
  label: string;
  value: string;
};

const row = (label: string, value: string | null | undefined): Row | null => {
  const trimmed = value?.trim();
  if (!trimmed) return null;
  return { label, value: trimmed };
};

const currentHealthPlanRows = (
  eligibility: UserEligibility,
  planName?: string | null
): Row[] => {
  const patient = eligibility.patient;
  const subscriber = eligibility.subscriber;
  const patientName = [patient?.first_name, patient?.last_name]
    .filter(Boolean)
    .join(' ');
  const subscriberName = [subscriber?.first_name, subscriber?.last_name]
    .filter(Boolean)
    .join(' ');
  const relationship = eligibility.relationship_to_subscriber
    ? (RELATIONSHIP_LABELS[eligibility.relationship_to_subscriber] ??
      eligibility.relationship_to_subscriber)
    : null;

  return [
    row('Health plan', planName),
    row('Name on card', patientName),
    row('Member ID', patient?.member_id),
    row('Group ID', eligibility.group_id),
    row('Relationship', relationship),
    row('Plan holder', subscriberName),
    row('Plan holder member ID', subscriber?.member_id),
    row('Plan holder date of birth', subscriber?.date_of_birth),
    row('Plan holder gender', subscriber?.gender),
  ].filter((item): item is Row => item !== null);
};

type Props = {
  eligibility: UserEligibility;
  planName?: string | null;
};

export const CurrentHealthPlan = ({ eligibility, planName }: Props) => {
  const rows = currentHealthPlanRows(eligibility, planName);
  if (rows.length === 0) {
    return <Text color="blueGray.600">Health plan on file.</Text>;
  }

  return (
    <Box as="dl">
      {rows.map((item) => (
        <Box key={item.label} mb={2}>
          <Text as="dt" color="blueGray.600" fontSize="13px">
            {item.label}
          </Text>
          <Text as="dd">{item.value}</Text>
        </Box>
      ))}
    </Box>
  );
};
